import { animateHeroElement } from './helpers';

export const educationInnerAnimation = () => {
	animateHeroElement(
		'.education-left-inner-image',
		{ rotate: -10 },
		{
			rotate: 0,
			x: 42,
			y: 7,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.education-left-inner-square',
		{},
		{
			rotate: 30,
			x: 44,
			y: 21,
			duration: 1,
			delay: 0.5,
			ease: 'shapeEasing',
		}
	);

	animateHeroElement(
		'.education-left-inner-square2',
		{},
		{
			rotate: 30,
			x: 27,
			y: 59,
			duration: 1,
			delay: 0.5,
			ease: 'shapeEasing',
		}
	);

	animateHeroElement(
		'.education-left-inner-circle',
		{},
		{
			x: 86,
			y: 57,
			duration: 0.72,
			delay: 0.8,
			ease: 'slowDown',
		}
	);

	animateHeroElement(
		'.education-right-inner-image',
		{ rotate: 15 },
		{
			rotate: 0,
			x: -44,
			y: 14,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.education-right-inner-square',
		{},
		{
			rotate: -45,
			x: -117,
			y: -41,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);

	animateHeroElement(
		'.education-right-inner-circle',
		{},
		{
			x: -21,
			y: 77,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);
};
